import React, { Component } from "react";
import { Link } from "react-router";
import moment from "moment";
import fileDownload from "js-file-download";

export default class RowItemVanBanXuLy extends Component {
  render() {
    const { ten, soQuyetDinh, ngayQuyetDinh, tenFile, duongDan } =
      this.props.item || [];
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{ten || ""}</td>
        <td>{soQuyetDinh || ""}</td>
        <td>
          {ngayQuyetDinh ? moment(ngayQuyetDinh).format("DD/MM/YYYY") : ""}
        </td>
        <td>
          <Link
            onClick={fileDownload.bind(this, duongDan, tenFile)}
            className="txt-underline txt-blue"
          >
            {tenFile || ""}
          </Link>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/quan-ly-ho-so/datatable/RowItemVanBanXuLy.jsx